import { connect } from 'react-redux';
import get from 'app/common/lib/get';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';

import Loader from 'app/components/Loader';


export default compose(
  withTranslation('subs'),

  connect(
    (state, { t }) => ({
      title: `${t('browser_title')} - ${state.dealer.project_name}`,
      header: t('header'),
      savedStudentId: get(state, 'settings.current.id', null),
      isLoading: state.settings.current.loading || state.apps.opts.loading || state.students.loading,
      students: state.students,
    })
  ),


  withHandlers({
    // редирект по умолчанию
    redirectOnLoad: ({ location, savedStudentId, students, params, router }) => (condition) => {
      const { pathname } = location;
      const studentId = savedStudentId || (students.keys.length && students.keys[0]);
      if (!students.keys.includes(studentId)) return;

      if (condition) {
        let urlReplace = pathname;
        if (!params.id) {
          urlReplace += `/${studentId}`;
        }
        if (!params.type) {
          urlReplace += '/assigned';
        }
        router.replace(urlReplace.replace('//', '/'));
      }
    },
  }),


  lifecycle({
    componentDidMount() {
      if (this.props.isLoading) return;
      this.props.redirectOnLoad(/^\/apps\/*(\d\/*)*$/.test(this.props.location.pathname));
    },

    // $FlowFixMe
    UNSAFE_componentWillReceiveProps(nextProps) {
      this.props.redirectOnLoad(
        this.props.isLoading
        && !nextProps.isLoading
        && /^\/apps\/*(\d\/*)*$/.test(this.props.location.pathname)
      );
    },
  }),


  branch(
    props => props.isLoading,
    renderComponent(Loader)
  )
);
